class Overlay {
    constructor() {
        this.$el = $('[data-overlay="el"]');
        this.$close = $('[data-overlay="close"]');
        this.$trigger = $('[data-overlay="trigger"]');

        this.init();
    }

    init = () => {
        this.$close.on('click', this.toggleOverlay);
        this.$trigger.on('click', this.toggleOverlay);
    }

    toggleOverlay = () => {
        this.$el.toggleClass('overlay--visible');
    }
}

export default Overlay;
